module.exports = __webpack_public_path__ + "img/nodeCloseBtn.99e88520.svg";